<template>
  <v-card>
    <v-card-title class="grey lighten-5 headline">
      Cadastro de Entidade
    </v-card-title>
    <v-row class="pa-4" justify="space-between">
      <v-col cols="12">
        <v-form v-model="valid" ref="form">
          <v-container>
            <v-row>
              <v-col :sm="vigenciaInicioDisabled ? '5' : '6'">
                <v-text-field
                  v-model="entidade.dataVigenciaInicio"
                  label="Inicio Data Vigencia"
                  clearable
                  :disabled="vigenciaInicioDisabled"
                  type="date"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col v-if="vigenciaInicioDisabled" sm="1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      icon
                      v-on="on"
                      class="mt-3"
                      @click="confirmarAlterarDataVigencia"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Data Início Vigência</span>
                </v-tooltip>
              </v-col>
              <v-col sm="6">
                <v-text-field
                  v-if="entidade.id != 0"
                  v-model="entidade.dataVigenciaFim"
                  label="Fim Data Vigencia"
                  clearable
                  type="date"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-select
                  :items="empresas"
                  label="Empresa"
                  :item-text="item => item.nome + ' - '+ item.id"
                  item-value="id"
                  v-model="entidade.empresaID"
                  :rules="[rules.required]"
                  required
                  @change="searchDepartamentosTimeOut()"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="mb-5">
              <v-col cols="6">
                <v-select
                  :items="departamentos"
                  label="Departamento"
                  item-text="caminhoCompleto"
                  item-value="id"
                  v-model="entidade.departamentoID"
                  :rules="[rules.required]"
                  :disabled="entidade.empresaID == 0"
                  required
                  @change="listaGrupos()"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  :items="grupos"
                  label="Grupo"
                  item-text="nome"
                  item-value="id"
                  v-model="entidade.grupoID"
                  :rules="[rules.required]"
                  required
                  :disabled="entidade.departamentoID == 0 || entidade.id != 0"
                  @change="listaGrupoPropriedades()"
                >
                  <template template v-slot:selection="{ item }">
                    <div>
                      <v-icon>{{ item.icone }}</v-icon>
                      <span>{{ `  ${item.nome}` }}</span>
                    </div>
                  </template>
                  <template v-slot:item="{ item }">
                    <div>
                      <v-icon>{{ item.icone }}</v-icon>
                      <span>{{ `  ${item.nome}` }}</span>
                    </div>
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <div v-if="entidade.grupoID !== 0">
              <h5>Propriedades da Entidade</h5>
              <v-divider></v-divider>
              <v-row
                v-for="prop in entidade.entidadePropriedades"
                :key="prop.grupoPropriedadeID"
              >
                <v-col>
                  <v-text-field
                    v-if="prop.grupoPropriedade.propriedadeInteligenteID"
                    :label="prop.grupoPropriedade.nome"
                    v-model="prop.valor"
                    v-mask="
                      adicionarMascara(
                        prop.grupoPropriedade.propriedadeInteligenteID
                      )
                    "
                    clearable
                    :rules="[rules.required]"
                    @change="
                      validarPropriedade(
                        prop.valor,
                        prop.grupoPropriedade.propriedadeInteligenteID
                      )
                    "
                    required
                  ></v-text-field>
                  <v-text-field
                    v-else
                    :label="prop.grupoPropriedade.nome"
                    v-model="prop.valor"
                    clearable
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <p>
              <v-btn @click="voltar" color="error" large>Voltar</v-btn>
              <v-btn
                @click="salvar"
                color="primary"
                large
                class="ml-2"
                :disabled="saving || block"
                >Salvar</v-btn
              >
            </p>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <TelaLoading :overlay="saving"></TelaLoading>
  </v-card>
</template>

<script>
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import DepartamentoService from "@/common/services/http/departamento.service";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";
// import moment from "moment";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import { SET_LOADING } from "@/store/config.module";

export default {
  name: "entidadeCadastro",
  data() {
    var dataVigencia = new Date(),
      mes = "" + (dataVigencia.getMonth() + 1),
      dia = "" + dataVigencia.getDate(),
      ano = dataVigencia.getFullYear();

    if (mes.length < 2) mes = "0" + mes;
    if (dia.length < 2) dia = "0" + dia;

    return {
      valid: false,
      saving: false,
      cliente: {},
      usuario: null,
      block: false,
      entidade: {
        id: 0,
        empresaID: 0,
        grupoID: 0,
        entidadePropriedades: [],
        // registros: [],
        dataVigenciaInicio: `${ano}-${mes}-${dia}`,
        dataVigenciaFim: null,
        departamentoID: 0,
      },
      empresas: [],
      grupos: [],
      departamentos: [],
      rules: {
        required: (v) => !!v || "Obrigatório",
      },
      vigenciaInicioDisabled: false
    };
  },
  components: {
    TelaLoading,
  },
  methods: {
    adicionarMascara(item) {
      switch (item) {
        case 1:
          return "###.###.###-##";
        case 2:
          return "##.###.###/####-##";
        default:
          return "";
      }
    },
    removerMascara() {
      this.entidade.entidadePropriedades.forEach((x) => {
        if (x.grupoPropriedade.propriedadeInteligenteID) {
          switch (x.grupoPropriedade.propriedadeInteligenteID) {
            case 1:
              x.valor = x.valor.match(/\d/g).join("");
              break;
            case 2:
              x.valor = x.valor.match(/\d/g).join("");
              break;
            default:
              break;
          }
        }
      });
    },
    async validarPropriedade(propriedadeValor, propriedadeInteligenteID) {
      try {
        this.saving = true;
        const {
          data: result
        } = await ApiService.get('entidade',
          `validar/propriedade/${propriedadeValor
            .match(/\d/g)
            .join(
              ""
            )}/propriedadeInteligenteID/${propriedadeInteligenteID}/cliente/${
            this.cliente.id
          }`,
          {entidadeId: this.entidade.id, empresaId: this.entidade.empresaID, departamentoID: this.entidade.departamentoID}
        );
        if (!result.success) {
          SweetAlert.sweetAlertError(result.errors);
          this.block = true;
        } else this.block = false;
        this.saving = false;
      } catch (ex) {
        this.saving = false;
      }
    },
    async listaEmpresas() {
      let empresas = [];

      if (this.usuario.usuario.tipoUsuario === 4) {
        const { data: result } = await ApiService.get(
          "empresa/getByUsuarioID/" + this.usuario.usuario.id
        );

        if (result.success && result.data != null) {
          empresas = result.data;
        } else SweetAlert.sweetAlertError(result.errors);
      } else {
        const { data: result } = await ApiService.get(
          "empresa/getbyclienteid/" + this.cliente.id
        );

        if (result.success) empresas = result.data.filter((x) => x.dataVigenciaFim == null);
        else SweetAlert.sweetAlertError(result.errors);
      }
      this.empresas = empresas;
    },

    async listaGrupos() {
      if (this.entidade.id == 0) {
        this.grupos = [];
      }
      // this.entidade.grupoID = 0;

      const { data: result } = await ApiService.get(
        "grupo/getByDepartamentoID/" + this.entidade.departamentoID
      );

      if (result.success) {
        this.grupos = result.data; 
        if (this.entidade.id == 0) {
          this.entidade.entidadePropriedades = [];
          this.entidade.grupoID = null;
        }
        
      }
      else SweetAlert.sweetAlertError(result.errors);
    
    },

    searchDepartamentosTimeOut() {
      this.entidade.departamentoID = 0;    
      this.departamentos = [];

      if (this.entidade.id == 0) {
        this.entidade.grupoID = 0;
        this.grupos = [];
      }
      
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.buscarDepartamentos();
      }, 500);
    },

    async listaGrupoPropriedades() {
      const { data: result } = await ApiService.get(
        "entidade/getPropriedadesPreencherByIdGrupo/" + this.entidade.grupoID
      );

      if (result.success) this.entidade.entidadePropriedades = [];
      else {
        SweetAlert.sweetAlertError(result.errors);
        return;
      }
      // this.entidade.registros = [];

      for (let index = 0; index < result.data.propriedades.length; index++) {
        const propriedade = result.data.propriedades[index];

        this.entidade.entidadePropriedades.push({
          entidadeID: 0,
          grupoPropriedadeID: propriedade.id,
          grupoPropriedade: propriedade,
          valor: "",
        });
      }

      // this.entidade.registros = result.data.registros;
    },

    async salvar() {
      let self = this;

      if (this.$refs.form.validate()) {
        this.saving = true;
        this.removerMascara();

        let dataVigenciaValida = this.validarDataVigencia(
          this.entidade.dataVigenciaInicio,
          this.entidade.dataVigenciaFim
        );

        if (dataVigenciaValida == false) {
          this.saving = false;
          return;
        }

        if (this.entidade.id != 0) {
          this.entidade.empresa = null;
          this.entidade.grupo = null;
          this.entidade.departamento = null;
        }

        const entidadeVm = JSON.parse(JSON.stringify(this.entidade));

        entidadeVm.entidadePropriedades = entidadeVm.entidadePropriedades.map(
          (r) => {
            r.grupoPropriedade = null;
            return r;
          }
        );

        const { data: result } =
          this.entidade.id === 0
            ? await ApiService.post("entidade/incluir", entidadeVm)
            : await ApiService.put(
                "entidade/atualizar/" + entidadeVm.id,
                entidadeVm
              );

        if (!result.success) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: result.errors[0] || "Ocorreu um erro inesperado",
            showConfirmButton: false,
            timer: 1500,
          });

          this.saving = false;

          return;
        }

        Swal.fire({
          position: "center",
          icon: "success",
          title:
            this.entidade.id === 0
              ? "Entidade Cadastrada com Sucesso!"
              : "Entidade Alterada com Sucesso!",
          showConfirmButton: false,
          timer: 1500,
        }).then(function () {
          self.$router.push({ name: "entidade" });
        });

        this.saving = false;
      }
    },

    async buscarEntidade(id) {
      const { data: result } = await ApiService.get("entidade/getbyid/" + id);

      if (result.success) {
        this.entidade = result.data;
        if (this.entidade.id != 0) {
          this.listaEmpresas();
          this.listaGrupos();
        }
        this.vigenciaInicioDisabled = true;
      } else SweetAlert.sweetAlertError(result.errors);
    },

    async buscarDepartamentos() {
      const result = await DepartamentoService.getDepartamentoByEmpresaID(
        this.entidade.empresaID,
        true
      );

      if (this.$route.params.id == undefined) {
        this.entidade.grupoID = 0;
        this.entidade.departamentoID = 0;
      }

      if (result.success) this.departamentos = result.data;
      else SweetAlert.sweetAlertError(result.errors);

      this.$store.commit(SET_LOADING, false);
    },

    voltar() {
      this.$router.push({ name: "entidade" });
    },

    getIndex(list, id) {
      return list.findIndex((e) => e.id == id);
    },

    validarDataVigencia(dataVigenciaInicio, dataVigenciaFim) {
      const vigenciaInicio = new Date(dataVigenciaInicio);
      let vigenciaFim = null;
      let hoje = Date.now();
      let dataAtual = new Date(hoje);
      dataAtual.setHours(0, 0, 0, 0);

      if (dataVigenciaFim != null) {
        vigenciaFim = new Date(dataVigenciaFim);

        if (vigenciaFim == null) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Data Vigencia Fim inválida",
            showConfirmButton: false,
            timer: 2500,
          });

          return false;
        }
      }

      if (vigenciaInicio == null) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Data Vigencia Inicio inválida",
          showConfirmButton: false,
          timer: 2500,
        });

        return false;
      }

      if (dataVigenciaFim != null) {
        if (vigenciaFim < vigenciaInicio) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Data Vigencia Inicio deve ser menor que Data Vigencia Fim.",
            showConfirmButton: false,
            timer: 3000,
          });

          return false;
        }
        // if (moment(dataAtual).diff(vigenciaFim, "day") > 30) {
        //   Swal.fire({
        //     position: "center",
        //     icon: "error",
        //     title:
        //       "Data Vigencia Fim não deve ter mais que 30 dias de retrocesso",
        //     showConfirmButton: false,
        //     timer: 3000,
        //   });

        //   return false;
        // }
      }

      return true;
    },

    confirmarAlterarDataVigencia() {
      Swal.fire({
        title: "Tem certeza que deseja alterar a Início Data Vigência?",
        text: "Essa ação pode incluir ou remover pendencias já existentes",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          this.vigenciaInicioDisabled = false;
        }
      });
    },
  },
  async mounted() {
    this.$store.dispatch(SET_LOADING, true);
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.usuario = JSON.parse(window.localStorage.getItem("usuario"));
    this.listaEmpresas();

    if (this.$route.params.id !== undefined) {
      await this.buscarEntidade(this.$route.params.id);
      await this.buscarDepartamentos();
    } else this.$store.commit(SET_LOADING, false);
  },
  created() {
    let permissao = Permissoes.Incluir;

    if (this.$route.params.id !== undefined) permissao = Permissoes.Editar;

    if (!PermissoesService.verificarAcesso(Modulo.Entidade, permissao)) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
